const saveTokensInLocaleStorage = (at, rt) => {
  localStorage.setItem("at", at)
  localStorage.setItem("rt", rt)
}

export default saveTokensInLocaleStorage